import { render, staticRenderFns } from "./UpdateTeamPersonnel.vue?vue&type=template&id=1795afd0&scoped=true&"
import script from "./UpdateTeamPersonnel.vue?vue&type=script&lang=js&"
export * from "./UpdateTeamPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTeamPersonnel.vue?vue&type=style&index=0&id=1795afd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795afd0",
  null
  
)

export default component.exports